export const HOME = "/:lan?/";
export const AI_ENABLED_CAMERA = "/AIEnabledCamera/";
export const Test_Guide = "/TestGuide/";
export const FIVE_SQUAT_TEST = "/SquatTest/";
export const MUSCLE_AGE_RESULTS = "/muscleAgeResults/";
export const TEST_COMPLETION_MESSAGE = "/testCompletionMessage/";
export const CAMERA_FALLBACK = "/cameraFallback/";
export const Manual_Test = "/manualTest/";
export const INSTRUCTIONS_MODAL = "/instructions/";
